export default {
  BUSINESS_PHONE: 'business-phone',
  BUSINESS_ADDRESS: 'business-address',
  BUSINESS_EMAIL: 'business-email',
  BUSINESS_HOURS: 'business-hours',
  BUSINESS_NAME: 'business-name',
  SITE_NAME: 'site-name',
};
